export const ActionTypes = {
  LOADING: "UPDATE_OPTIONS_LOADING",
  ERROR: "UPDATE_OPTIONS_ERROR",
  SUCCESS: "UPDATE_OPTIONS_SUCCESS",
};
